import React from "react";

import "./Loading.css"

const LoadingPage = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <h1 className="loading-text">Mappix</h1>
      </div>
    </div>
  )
}

const LoadingPageSecond = () => {
  return (
    <div className="loading-container2">
      <div className="loading-content2">
        <h1 className="loading-text2">Mappix</h1>
      </div>
    </div>
  )
}

export { LoadingPage, LoadingPageSecond }
